module.exports = __webpack_public_path__ + "img/li_highlight.49f690cd.png";